<template>
  <div id="form" class="modal with-header white" ref="modal">
    <div class="header-wrapper">
      <div class="modal-header">
        <div class="title">
       <span v-if="content" v-html="content.title.rendered"></span>
        </div>
        <ul class="right">
          <li>
            <a @click="$_toggleFullScreen()">
              <i v-if="!fullScreen" class="material-icons grey-text text-darken-3">
                fullscreen
              </i>
              <i v-else class="material-icons grey-text text-darken-3">
                fullscreen_exit
              </i>              
            </a>
          </li>
          <li>
            <a class="goBack" @click="$_goBack()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
        <div class="pl-wrapper">
          <div class="progress" v-if="sending">
              <div class="indeterminate"></div>
          </div>
          </div>
    <transition name="fade-in">
   
   <div class="modal-content grey lighten-5" v-if="ready">
    <div class="form-fields" v-if="state === 'edit'">
      <div 
      :class="field.layout"
      v-for="(field, index) in fields" v-bind:key="index">
        <field-types

          @uploads="$_filesToUpload($event)"
          @update="$_fieldsData($event)"
          :data-option="field"
        >
        </field-types>
      </div>
    </div>
    <div v-else>
      <div 
        :class="field.layout"
        v-for="(field, index) in fields" v-bind:key="index">
      <div class="view_label" :class="[field.name]">{{field.label}}:</div>
        {{field.name ===  'name'
          ? content.title.rendered
           : field.name !== 'logs' && field.name !== 'other_attachments' &&  field.name !== 'judges' && field.name !== 'file_links' && field.name !== 'status' && field.name !== 'request_form'
            ? content.acf[field.name]
            :''
        }}
        <div v-if="field.name === 'status'">
          <span class="left badge new" style="margin-left:0px; text-transform: capitalize" :class="statusColor(content.acf[field.name])" :data-badge-caption="content.acf[field.name]"></span>
        </div>
        <div v-if="field.name === 'judges'">
          <span class="chip user" v-for="(judge, ji) in content.acf[field.name]" :key="ji * 1.339"><i class="material-icons left">account_circle</i>{{judge.judge}}</span>
        </div>
        <div class="logs" v-if="field.name === 'logs'">
          <div class="col s12 " v-for="log in content.acf[field.name]" :key="log.id">
            
            <div class="card">
              <div class="card-content">
                <blockquote>
                  <div class='date-meta'>{{$_formatDate(log.date, 'DD-MM-YYYY: hh:mm a')}}</div>
                 "<span v-html="log.message"> </span>"
                </blockquote>
              </div>
            </div>
          </div>
        </div>
          <ul v-if="field.name === 'other_attachments'">
          <li v-for="(a, i) in content.acf[field.name]" :key="i">
              <a target="_blank" :href="a.url">{{a.filename}}</a>
          </li>
        </ul>
      <!--   <a v-if="field.name === 'request_form'" target="_blank" :href="content.acf[field.name].url">{{content.acf[field.name].filename}}
        </a> -->
        <ol class="browser-default" v-if="field.name === 'file_links'">
          <li v-for="(a, i) in content.acf[field.name]" :key="i">
              <a target="_blank" :href="a.url">{{a.url}}</a>
          </li>
        </ol>
      </div>
    </div>
     <div>
     </div>
     <div class="noti-options" v-if="notify">
          <div class="col s12">
            <label v-for="(x, i) in toPost.logs" :key="i">
              <input type="checkbox"  :value="{date: x.date, message:x.message}" v-model="notificationLogs"/>
              <span class="grey-text text-darken-3">{{x.message}}</span>
            </label>
          </div>
        </div>
   </div>
    </transition>
    
        
   <div class="loader-container" v-if="!ready">
        <div 
        class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
   </div>
    <div class="custom-footer">
      <div class="col left">
      <p style="margin:0px;">
        <label>
          <input v-model="notify"  type="checkbox" />
          <span>Send Notification</span>
        </label>
      </p>
      </div>
      <button v-if="state === 'edit'"
        :disabled="sending"
        @click="$_saveCheck()"
        class="btn z-depth-0 right waves-effect">
        Update 
      </button>
      <button class="btn btn-flat waves-effect transparent right" @click="$_goBack()">
        Go Back
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import formService from '@/services/formService'
import core from '@/functions'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
import recordFields from '@/components/transcripts/transcripts-incoming'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'
export default {
  name:'formView',
  components:{
    fieldTypes,
  },
  data(){
    return {
     // fields:recordFields.fields,
      curr_index:0,
      notify:false,
      notificationLogs: [],
      state: 'view',
      post: new Object,
      content: false,
      sending:false,
      fullScreen:false,
      ready:false,
      popFields: {},
      uploads:{
        data:new Array,
        ready:false,
        added:new Array, 
      },
      modal:{
        options:{
          onOpenStart:()=>{
              
          },
          onOpenEnd:()=>{
            core.updateFields()
          },
          dismissible:false
        },
        instance:null,
      }
    }
  },
  watch:{
    $route:function(nV){
      nV 
      ? this.modal.instance.close()
      : false
    },
  },
  created () {
    this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)
    if (this.$route.name === 'view_entry'){
      this.$_fetchTs()
    }
  },
  mounted(){
    
    this.$route.query.state && this.$route.query.state === 'edit'
      ? this.state = 'edit'
      : this.state = 'view'    
    this.$_vModal()
 

  },
  beforeDestroy(){
    try{
      this.modal.instance.close()
      this.modal.instance !== null 
      ? this.modal.instance.destroy()
      : false
    }catch(e){
      //console.log(e)
    }
  },
  computed:{
    ...mapState({
      users:state=> state.record.users,
      records:state => state.record.records,

    }),
    fields:{
      get(){
        return this.$route.name === 'view_entry' ?  recordFields.generate() : this.popFields
      }
    },
    toPost: {
      get () {
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : false
        }
        return {
          name: mapValue('name'),
          case_number: mapValue('case_number'),
          requesting_party: mapValue('requesting_party'),
          email:mapValue('email'),
          turn_around_time: mapValue('turn_around_time'),
          practitioners: mapValue('practitioners'),
          hearing_dates: mapValue('hearing_dates') ? mapValue('hearing_dates').map(e => {return {date: e.date}}) : '',
          transcriptionist: mapValue('transcriptionist') ?  mapValue('transcriptionist').prop : '',
          heard: mapValue('heard'),
          contact: mapValue('contact'),
          case_name: mapValue('case_name'),
          judges: mapValue('judges') ? mapValue('judges').map(e => {return {judge: e.judge}}) : '',
          appearances: mapValue('appearances'),
          logs: mapValue('logs'),
          status: mapValue('status') ? mapValue('status').prop : '',
          file_links: mapValue('file_links'),
          other_attachments: this.uploads.added.length > 1 
            ? [...this.uploads.added.map(item=> {return {id:item.file}}), mapValue('other_attachments') ?  mapValue('other_attachments').map(x => {return {ID: x.id}}) : []]
            : mapValue('other_attachments') ?  mapValue('other_attachments').map(x => {return {ID: x.id}}) : []
        }
      }
    },
    validateForm:{
      get(){
        return true //this.post.to !== '' & this.post.to !== undefined ? true: false 
      }
    }
  },
  methods: {
    $_formatDate(date, format){
			return core.dateFormat(new Date(date), format)
    },
		statusColor(s){
		return s === 'not-started'
				? 'indigo accent-4'
				: s === 'on-hold'
					? 'yellow darken-2 brown-text'
					: s === 'pending'
						? 'yellow darken-2 grey-text text-darken-3'
						: s === 'complete'
							? 'green accent-4'
							: 'red white-text'
		},
    $_fetchTs() {
      contentService.getTranscript(this.$route.params.id) 
      .then(res => { 
      this.content  = res.data
      this.popFields =  recordFields.populate({name: res.data.title.rendered, ...res.data.acf})
      setTimeout(() => {
       core.updateFields()
       this.ready = true
      });
      })
    },
    $_vModal(){
      this.modal.instance = core.initModal(this.$refs.modal, this.modal.options)
      setTimeout(() => {
        this.modal.instance.open()
      }, 300);
    },
    $_filesToUpload($event){
     this.uploads.data.length < 0
     ? this.uploads.data = $event.data
     : this.uploads.data = $event.data//[...this.uploads.data, ...$event.data]
    },
    $_processFiles(){
 
      let promises = this.uploads.data.map(item => contentService.uploadFile(item.data))
      const count =  {
          promises:promises.length,
          sucess:0,
          files:new Array,
      }
      Promise.all(promises)
        .then(res=>{         
         count.sucess = count.sucess + 1
         count.files.push({file:res[count.sucess - 1].data.id})
         this.uploads.added.push({file:res[count.sucess - 1].data.id})
         if(count.promises === count.sucess) {
          
           this.uploads.ready = true
           this.$_saveRecord()
            window.console.log('uploadDone')          
          }        
        })
    },
    $_fieldsData($event){
      let log_structure = (v) => {
        return {
          id:v.id,
          date: new Date,
          message: v.notes
        }
      }
      let judge_structure =  (j) => {
        return {
          judge : j.notes
        }
      }
      let file_links =  (f) => {
        return {
          url : f.notes
        }
      }
      const record =  this.fields.find(item => item.name === $event.name)
      if ( $event.name === 'logs') {
          record.values = $event.data.map(item => log_structure(item))
      } else if ($event.name === 'judges') {
         record.values = $event.data.map(item => judge_structure(item))
      } else if ($event.name === 'file_links') {
         record.values = $event.data.map(item => file_links(item))
      } else {
        if(record){
          if(record.name === 'from' || record === 'to') record.values = $event.data
          else record.values = $event.data
        } 
      }
     this.post = this.$_postStructure()
    },
    $_toggleFullScreen(){ 
        this.$refs.modal.classList.toggle('fullScreen')  
        let test = () => {
           return  this.$refs.modal.classList.contains('fullScreen')
        } 
       if(test()) {
          this.fullScreen = true
       }
      if(!test()) {
        this.fullScreen = false        
      }
    },
    $_goBack(){
      this.$router.go(-1)
    },
    $_editValues($event){
      let payload = {
        action:'update_field_values',
        uid:$event.field,
        data:$event.values
      }
      this.$store.commit('ADD_FIELDS_DATA', payload)
    },
    $_sendNotificaiton(data){
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : false
        }
      let payload = {
        case_number: this.toPost.case_number,
        logs: this.notificationLogs.map((x, i) => {return `${core.dateFormat(x.date, 'Do MMM YYYY hh:mm a')}\n ${i+1}. ${x.message}\n\n`}).toString().replaceAll(',', ''),
        status:this.toPost.status,
        url:`https://docs.eccourts.org/transcripts/transcript/view/${data.id}`,
      }

    let payload_two = {
          requestEmail:this.toPost.email,
          transcriptionistEmail:mapValue('transcriptionist') ?  mapValue('transcriptionist').email : '',
          caseName:this.toPost.case_name,
          adminUrl:'https://docs.eccourts.org/incoming-transcripts/27',
          userUrl:'https://docs.eccourts.org',
          requestingParty:this.toPost.requesting_party,
          case_number:this.toPost.case_number,
          transcriptionist:this.toPost.transcriptionist,
          _wpcf7_unit_tag: null,
          practitioners:this.toPost.practitioners,
          heard: this.toPost.heard,
          file_links: this.toPost.file_links && this.toPost.file_links.length > 0 ? this.toPost.file_links[0].url : '',
          judges:this.toPost.judges.length > 0 ? this.toPost.judges.map(j => {return `${j.judge}`}).toString() : '',
          appearances:this.toPost.appearances,
          hearing_dates: this.toPost.hearing_dates.length > 0 ? this.toPost.hearing_dates.map(d => {return `${d.date}`}).toString() : '',
          turn_around_time:this.toPost.turn_around_time+' days',
      }
    
      let fid = 0
      let toSend = {}
      if (this.toPost.status === 'complete' ){
        fid = 3586
        payload_two._wpcf7_unit_tag = "487e04b"
        toSend = payload_two
      } else {
        fid = 3587
        payload_two._wpcf7_unit_tag = "5783475"
        toSend = payload
      }
      formService.newRequest(toSend, fid)
      .then(() =>{ 
        this.sending = false
      })
      .catch(e => {
        this.sending = false
        return e
      })
    },
    $_postStructure(){
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : ''
        }
        let recordX =  {
          name: mapValue('name'),
          case_number: mapValue('case_number'),
          requesting_party: mapValue('requesting_party'),
          transcriptionist: mapValue('transcriptionist'),
          case_name: mapValue('case_name'),
          judges: mapValue('judges') ? mapValue('judges').map(e => {return {judge: e.notes}}) : '',
          appearances: mapValue('appearances').prop,
          logs: mapValue('logs'),
          status: mapValue('status') ? mapValue('status').prop : '',
          file_links: mapValue('file_links'),
          other_attachments: this.uploads.added.map(item=> {return {id:item.file}})
        }
        
        return recordX
    },
    $_saveCheck(){
      this.sending = true
      if ( this.uploads.data.length > 0){
        this.$_processFiles()
      } else {
        setTimeout(() => {
          this.$_saveRecord()
        }, 300);
      }
    },
    $_saveRecord(){
      
      //const post = this.post
      const structure = {
        title: this.fields.find(item => item.name === 'name' ).values,
        status:'publish',
        fields:{
          ...this.toPost,
          // other_attachments: this.uploads.added.map(item=> item.file)
        }
      }

       const dontThink = () => {
          return  this.content.acf.other_attachments
          ? this.content.acf.other_attachments.map(x => x.ID)
          : []
        }
      if(this.uploads.added.length > 0) {
       
        let modObject = [
          ...this.uploads.added.map(item=> item.file),
          ...dontThink()
          ]
         structure.fields.other_attachments = modObject
        } else {
          let modObject = [
          ...dontThink()
          ]
         structure.fields.other_attachments = modObject
        }

     contentService.updateTranscript(structure, this.$route.params.id)
      .then(res=>{
     
   
        this.notify 
        ? this.$_sendNotificaiton(res.data)
        : false

   core.toastMessage('Update Successful')
       
        setTimeout(() => {
          this.ready = true
          this.sending = false
        }, 600);   
      })   
    },
  }
}
</script>
<style lang="scss" scoped>
#form{
  &.modal {
     min-height: 85% !important;
    &.fullScreen {
      top: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
    }
    .pl-wrapper {
      position: absolute;
      left: 0;
      top: 46px;
      right: 0;
  }
  }
  @media screen and (max-width: 680px){
    width:100%;
    top:0% !important;
    height: 100%;
    min-height: 100%;
  }
  &.modal.with-header {
    padding: 0;
    border-radius:6px;
    height: 70%;
  .header-wrapper {
    height:56px;
    position: relative;
    .modal-header {
      position: absolute;
      width:100%;
      padding:20px;
      top: 0;
      line-height:56px;
      height:100%;
      padding:0px 20px;
      border-bottom: .4px solid rgba(0,0,0,0.4);
      .title {
        font-size: 20px;
        width: calc(100% - 174px);
        overflow: hidden;
        text-overflow: ellipsis;
        float: left;
        line-height: 54px;
        white-space: nowrap;
      }
      ul {
        display: inline-flex;
        margin:0px;
         li {

           a {
             cursor: pointer;
             margin:0 8px;
              i {
                line-height: 56px;
              }
           }
         }
      }
    }
  }
  .modal-content {
    position: absolute;
    height: calc(100% - 122px);
    max-height: 100%;
    width: 100%;
    top:56px;
    padding:20px;
    overflow-y: auto;
  }
 }
  .custom-footer {
    position: fixed;
    bottom: 0;
    left:0;
    padding: 15px;
    width: 100%;
    background: white;
  }

.loader-container {
  top:50%;
  left:50%;
  width:64px;
  height: 64px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9;
}

}
</style>
<style lang="scss">
.view_label {
    font-size: 15px;
    letter-spacing: 1px;
    border-bottom: 1px solid #c7c7c7;
    padding: 7px 0px;
    margin: 8px 0px 7px;
    color: #14258a;
    font-weight: 500;
}
.logs {
  .card {
    border-radius: 6px;
    .card-content  {
      padding: 0px 12px 0 0;
      blockquote {
        margin: 0 0 20px 0;
        border-left: 5px solid #304ffe;
        padding: 22px;
      }
    }
  }
}
#form {
    .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      
      color:black;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default),
    input[type=email]:not(.browser-default),
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
      background:white;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
      background:white;
    }
}
</style>